import { Button, Callout, Intent, TextArea } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";

export default class JsonEditor extends React.PureComponent<{data: object, onSave: (config) => void}, {value: string, message: string, intent: Intent}> {

	constructor(props) {
		super(props);
		this.state = {value: JSON.stringify(props.data, null, 4), message: null, intent: Intent.NONE};
	}

	private handleChange = (e: any) => {
		this.setState({value: e.target.value});
	}

	private save = () => {
		try {
			const data = JSON.parse(this.state.value);

			this.props.onSave(data);

			this.setState({message: "Saved", intent: Intent.SUCCESS, value: JSON.stringify(data, null, 4)});
		} catch (e) {
			this.setState({message: "Invalid json. Not saved.", intent: Intent.DANGER});
		}
	}

	public render() {
		const { value, message, intent} = this.state;

		return (
			<div style={{display: "grid", gridTemplate: '"top" auto "middle" 1fr "bottom" auto'}}>
				{message && (
					<Callout intent={intent} style={{gridArea: "top", marginBottom: "15px"}}>
						{message}
					</Callout>
				)}
				<TextArea
					large={true}
					intent={Intent.PRIMARY}
					onChange={this.handleChange}
					value={value}
					style={{minHeight: "250px", gridArea: "middle", marginBottom: "15px", fontFamily: "monospace", fontSize: "13px"}}
					fill={true}
				/>
				<Button onClick={this.save} style={{gridArea: "bottom"}}>
					Save
				</Button>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/core/components/editor/JsonEditor.tsx